import { t } from 'i18next';
import { AlertTriangle } from 'lucide-react';

// The icon doubles the red: colour alone does not carry the alert for a
// colour-blind reader.
export const StatValue = ({
  value,
  isAlert,
}: {
  value: string;
  isAlert: boolean;
}) => (
  <span
    className={
      isAlert
        ? 'flex items-center gap-1.5 text-2xl font-medium tabular-nums tracking-tight text-destructive'
        : 'text-2xl font-medium tabular-nums tracking-tight'
    }
  >
    {value}
    {isAlert && (
      <AlertTriangle
        className="size-5 shrink-0"
        role="img"
        aria-label={t('Alert')}
      />
    )}
  </span>
);
